import "./Statistics.scss";
import { Statistic, Skeleton } from "antd";

type StatisticsItem = {
  label: string;
  value: string | number;
  key: string;
  onClick?: () => void;
};

type StatisticsProps = {
  statisticsItems: StatisticsItem[];
  isLoading?: boolean;
};

const StatisticsWidget = ({ statisticsItems, isLoading }: StatisticsProps) => {
  return (
    <div className="statistics-widget">
      <div className="statistics-group">
        {isLoading ? (
          <Skeleton active paragraph={{ rows: 2 }} title={false} />
        ) : (
          statisticsItems.map((item: StatisticsItem) => (
            <div
              key={item.key}
              className={`statistic-item ${item.onClick ? "interactive" : ""}`}
              role={item.onClick ? "button" : undefined}
              tabIndex={item.onClick ? 0 : -1}
              onClick={item.onClick}
              onKeyDown={(event) => {
                if (!item.onClick) return;
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  item.onClick();
                }
              }}
            >
              <Statistic
                title={item.label}
                value={item.value as string}
                valueRender={() => <span>{item.value || 0}</span>}
              />
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default StatisticsWidget;
